import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { thunk } from 'redux-thunk';
import rootReducer from '../reducers';

const sagaMiddleware = createSagaMiddleware();

let middleware;
if (process.env.REACT_APP_TEMP_MEE_ENV === 'production') {
  middleware = applyMiddleware(sagaMiddleware, thunk);
} else {
  middleware = applyMiddleware(sagaMiddleware, thunk, createLogger());
}

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(middleware));

export { sagaMiddleware, store };
